import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Button from '../../../components/Button'

import usePermissions from '../../../hooks/usePermissions'

import { rightsListWasLoadedSelector } from '../../../modules/selectors/rights'
import { selectedPartnershipIsDigitalSelector } from '../../../modules/selectors/partnerships'

import useSummaryPagesStyles from '../../../styles/common/summaryPages'

const SimplePartnershipsContent = ({ WelcomeMessage, isDigitalRightExist, openLatestDigitalRight }) => {
  const summaryPagesClasses = useSummaryPagesStyles()

  const { t } = useTranslation()
  const permissions = usePermissions()

  const rightsWasLoaded = useSelector(rightsListWasLoadedSelector)
  const selectedPartnershipIsDigital = useSelector(selectedPartnershipIsDigitalSelector)

  const showWelcomeMessage = useMemo(
    () => selectedPartnershipIsDigital && rightsWasLoaded && isDigitalRightExist && permissions.can('Create', 'Ad'),
    [isDigitalRightExist, permissions, rightsWasLoaded, selectedPartnershipIsDigital]
  )

  return (
    <>
      {showWelcomeMessage && (
        <>
          {WelcomeMessage}
          <div className={summaryPagesClasses.welcomeButtonsWrapper}>
            <Button onClick={openLatestDigitalRight}>{t('Upload a digital ad creative')}</Button>
          </div>
        </>
      )}
    </>
  )
}

SimplePartnershipsContent.propTypes = {
  WelcomeMessage: PropTypes.node.isRequired,
  isDigitalRightExist: PropTypes.bool.isRequired,
  openLatestDigitalRight: PropTypes.func.isRequired
}

export default SimplePartnershipsContent
